/** COMMON */

export const TEXT_REGULATED_PRODUCTS = 'text_regulated_products';
export const CONTRACT_TYPE_CHANGE = 'details_contract_type_change';
export const INCENTIVE_CODE = 'incentive_code';

export const INCENTIVE_VALUE = 'incentive_value';
export const INCENTIVE_CODE_TEXT = 'incentive_code_text';
export const KWK_CODE = 'kwk_code';
export const CUSTOMER_TYPE = 'type';

export const SELF_SERVICE_REGISTRATION_DISPLAY_TYPE = 'data_self_service_registration';
export const SHOW_MARKETING_OPTIN = 'data_check_opt_in';
export const BILLING_DIFFERENT_RECIPIENT_NAME = 'data_billing_abw_re';

/** PERSONAL DATA */

export const PERSONAL = {
  TITLE: 'title',
  FIRSTNAME: 'firstname',
  LASTNAME: 'lastname',
  COMPANY: 'firma',
  COMPANY_SUPPLEMENT: 'zusatz',
  PARTNER_TITLE: 'partner_data_title',
  PARTNER_FIRSTNAME: 'partner_data_firstname',
  PARTNER_LASTNAME: 'partner_data_lastname',
} as const;

/** CONTRACT DATA */
export const CONTRACT_LIST = 'contract';

export const CONTRACT = {
  SOLICITOR_GP_NR: 'solicitor_gp_nr',
  SOLICITOR_EMAIL: 'solicitor_email',
  REWARD_TYPE: 'reward_type',
  SOLICITOR_SPLITTING_FACTOR: 'solicitor_splitting_factor',
  SOLICITOR_CONTRACT_NR: 'solicitor_contract_nr',

  // Shipping Address
  SHIPPING_ADDRESS_STREET: 'shipping_address_street',
  SHIPPING_ADDRESS_HNR: 'shipping_address_hnr',
  SHIPPING_ADDRESS_ZIP: 'shipping_address_zip',
  SHIPPING_ADDRESS_CITY: 'shipping_address_city',

  // Contract Details
  DELIVERY_DESIRED_BEGINNING: 'delivery_desiredbeginning',
  COUNTER_READING: 'counter_reading',
  COUNTER_NUMBER: 'counter_number',

  // Utilities Change
  UTILITIES_CHANGE_ACCOUNT_PROVIDER: 'utilitieschange_account_provider',
  UTILITIES_CHANGE_CANCELLATION_TYPE: 'utilitieschange_cancellation_type',
  UTILITIES_CHANGE_CANCELLATION_DONE_WHEN: 'utilitieschange_cancellation_cancellationDone_cancellationDoneWhen',

  // Product Information
  PRODUCT_ID: 'tariff_product_id',
  PRODUCT_NAME: 'tariff_product_name',
  PRODUCT_CATEGORY: 'tariff_product_category',
  PRODUCT_WORKING_PRICE: 'tariff_product_workingprice',
  PRODUCT_WORKING_PRICE_NT: 'tariff_product_workingprice_nt',
  PRODUCT_YEARLY_PRICE: 'tariff_product_yearlyprice',
  PRODUCT_BASE_PRICE: 'tariff_product_baseprice',
  PRODUCT_MONTHLY_PRICE: 'tariff_product_monthlyprice',
  PRODUCT_PRICE_DATE: 'tariff_product_price_date',
  PRODUCT_DURATION: 'tariff_product_duration',
  PRODUCT_TARGET_GROUP: 'tariff_product_target_group',

  // Contract Type & Bonus
  IS_ONLINE_CONTRACT: 'tariff_online_contract',
  BONUS: 'tariff_bonus',
  BONUS_DIRECT: 'tariff_bonus_direct',
  EXPECTED_CONSUMPTION: 'tariff_consumption',

  // Optional Display
  SHOW_OPTIONAL: 'show_optional',

  // Terms & Conditions
  TEXT_PRICE_GUARANTEE: 'text_price_guarantee',
  TEXT_MSB: 'text_msb',
  TEXT_AGB: 'text_agb',
  TEXT_PRODUCT_NOTICE: 'text_product_notice',
  TEXT_MIN_DURATION: 'text_min_duration',
  TEXT_TERMINATION_NOTICE: 'text_termination_notice',
} as const;

export const BANKING = {
  SEPA_CHECK: 'data_sepa_check',
  IBAN: 'data_banking_iban',
} as const;

export const INVOICE = {
  STREET: 'data_invoice_address_street',
  HNR: 'data_invoice_address_hnr',
  ZIP: 'data_invoice_address_zip',
  CITY: 'data_invoice_address_city',

  /* foreign */
  COUNTRY: 'data_shipping_foreign_invoice_country',
  FOREIGN_ADDRESS: 'data_shipping_foreign_invoice_address',
  ADDITIONAL: 'data_invoice_address_additional',

  POST_BOX: 'data_invoiceAddress_usePostbox_postbox',
} as const;
